module.exports = __webpack_public_path__ + "media/images/twitter_black-d7c217b3fcfd5e9fd17e6e6a9aaa6415.png";